import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { JobService } from 'src/app/services/sections/job/job.service';
import { ReportService } from 'src/app/services/sections/job/report.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import moment from 'moment';
import { WorkforceReport } from 'src/app/models/workforce-report.model';
import { LookupService } from 'src/app/services/lookup.service';
import { AssetItemDetails } from 'src/app/models/asset-item-details.model';
import { SiteService } from 'src/app/services/site.service';

@Component({
	selector: 'workforce-report',
	templateUrl: './workforce-report.component.html',
	styleUrls: ['./workforce-report.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss', '../stylesheets/job-inputs.scss']
})
export class WorkforceReportComponent implements OnInit {

	public isDataLoading = false;

	public reportFormGroup: FormGroup;

	public isEmailCached: boolean;
	public isRequestSent: boolean;
	public isEmailInvalid: boolean;
	public isDateSelected: boolean;

	public assetId: number;
	public onDemandDates: string[];
	public selectedDate: Date;

	public assetDetails: AssetItemDetails;

	public readonly moment = moment;

	constructor(
		private activatedRoute: ActivatedRoute,
		private reportService: ReportService,
		private siteService: SiteService
		) { }

	ngOnInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;

		this.isEmailCached = !!localStorage.getItem('cloud-email');

		this.reportFormGroup = new FormGroup({
			date: new FormControl(null, Validators.required),
			email: new FormControl(this.isEmailCached ? localStorage.getItem('cloud-email') : '', [Validators.required, Validators.email, Validators.minLength(3), Validators.pattern(/\S+/)])
		});

		this.reportFormGroup.get('email').valueChanges.subscribe(
			value => {
				this.isEmailInvalid = this.isEmailInvalid && !this.isRequestSent ? false : this.isEmailInvalid;
				this.checkCrtValue();
			}
		);

		this.reportFormGroup.get('date').valueChanges.subscribe(date => {
			this.isRequestSent = false;
		});

		this.assetId = parseInt(this.activatedRoute.snapshot.paramMap.get('assetId'), 10);
		this.getAssetDetails(this.assetId);
		this.getCompletedOnDemandDates(this.assetId);
	}

	private checkCrtValue(){
		const model = this.reportFormGroup.getRawValue();
		if (model.email.indexOf(' ') >= 0){
			this.reportFormGroup.patchValue({email: model.email.replaceAll(' ', '')});
		}
	}

	public 	keyPressed($event: any) {
		if ($event.keyCode === 13 /*Enter */){
			this.checkEmail();
		}
	}

	public checkEmail(): void {
		this.isDataLoading = true;
		const formData = this.reportFormGroup.getRawValue();
		const request = {} as WorkforceReport;
		request.emailAddress = formData.email;
		request.date = formData.date;
		this.reportService.requestWorkforceReport(this.assetId, request).subscribe(res => {
			this.isDataLoading = false;
			this.isRequestSent = true;
			localStorage.setItem('cloud-email', formData.email.trim());
		}, error => {
			this.isDataLoading = false;
			this.isEmailInvalid = true;
		});
	}

	public getCompletedOnDemandDates(assetId): void {
		this.isDataLoading = true;
		this.reportService.getCompletedOnDemandDates(assetId).subscribe(res => {
			this.onDemandDates = res;
		}, error => this.isDataLoading = false,
		() => this.isDataLoading = false);
	}

	public getAssetDetails(assetId: number): void{
		this.siteService.getAssetDetails(assetId).subscribe(res => {
			this.assetDetails = res;
		});
	}
}
